import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import {postSubmit, isEmpty, scrollToComponent, stringToDate, formatDate, FORMAT_DATE_BACK} from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { stockAssDetailsEvolutionFilters, stockAssDetailsSummaryFilters } from "../../@signals"


export default function useStockAssortmentEvolutionStatusSkuChartData() {
	const { showToast } = useAppToast()

	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal({})
	const dataEvolutionColor = useSignal({})
	const dataEvolutionStatus = useSignal({})
	const skuName = useSignal('')
	const retailerName = useSignal('')
    const dateRange = useSignal([])
	const isLoadingDataEvolution = useSignal(false)

    useEffect(() => {
		if (!isEmpty(stockAssDetailsEvolutionFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(`${WEBBACK_V2_API}/stock-assortment/details/evolution`, {
				...stockAssDetailsSummaryFilters.value,
				...stockAssDetailsEvolutionFilters.value
			}).then(res => batch(() => {
				dataEvolution.value = res.chart
				dataEvolutionKeys.value = res.keysData
				dataEvolutionColor.value = res.keysColor
				dataEvolutionStatus.value = res.statusList
				skuName.value = res.skuName
				retailerName.value = stockAssDetailsEvolutionFilters.value.siteName
                dateRange.value = [stringToDate(stockAssDetailsEvolutionFilters.value.startDate), stringToDate(stockAssDetailsEvolutionFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => showToast.error()
            ).finally(() => scrollToComponent('evolution-status-chart')))
		}) 

		if (isEmpty(stockAssDetailsEvolutionFilters.value)) batch(() => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
		})

	}, [JSON.stringify(stockAssDetailsEvolutionFilters.value)])

    const onChange = (e) => {
        batch(() => {
            dateRange.value = e
            stockAssDetailsEvolutionFilters.value = {
                ...stockAssDetailsEvolutionFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		dataEvolutionColor.value = {}
		dataEvolutionStatus.value = {}
		dateRange.value= []
		stockAssDetailsEvolutionFilters.value = {}
	})

	return {
		dataEvolution: dataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		dataEvolutionColor: dataEvolutionColor.value,
		dataEvolutionStatus: dataEvolutionStatus.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		skuName: skuName.value,
		retailerName: retailerName.value,
        dateRange: dateRange.value,

        onChange,
        resetEvolutionData
	}
}